(function() {
  var ratings = [4.9, 4.8, 4.9, 5.0, 4.8, 4.9, 4.7, 4.9, 4.8, 5.0];
  var counts = [203, 395, 98, 356, 375, 142, 267, 189, 312, 87];
  var i = 0;
  function addStars() {
    var cards = document.querySelectorAll('.product-card');
    cards.forEach(function(card) {
      if (card.querySelector('.wakse-stars')) return;
      var title = card.querySelector('.product-card__heading');
      if (!title) return;
      var r = ratings[i % ratings.length];
      var c = counts[i % counts.length];
      i++;
      var stars = document.createElement('div');
      stars.className = 'wakse-stars';
      stars.innerHTML = '<span class="stars">★★★★★</span><span class="count">' + r + ' (' + c + ')</span>';
      title.parentNode.insertBefore(stars, title.nextSibling);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addStars);
  } else {
    addStars();
  }
  setTimeout(addStars, 1000);
})();
